module.exports = __webpack_public_path__ + "img/35.ebbe7eb3.jpg";